export const payList = [{
  label: '支付宝',
  value: 0
}, {
  label: '微信',
  value: 1
}, {
  label: '对公账户',
  value: 2
}]
export const config = [
  {
    label: 'BladeX企业版',
    value: 1,
    money: 5000
  }, {
    label: 'BladeX数据大屏平台',
    value: 5,
    money: 5999
  }, {
    label: 'BladeX物联网平台',
    value: 6,
    money: 8999
  }, {
    label: 'BladeX大模型平台',
    value: 8,
    money: 11999
  }, {
    label: 'BladeX联合版',
    value: 3,
    money: 8999
  }, {
    label: 'BladeX大模型企业版',
    value: 9,
    money: 15000
  }, {
    label: 'BladeX旗舰版',
    value: 10,
    money: 26999
  }
]
export const plugin = [
  {
    label: '工作流插件',
    value: 1,
  }, {
    label: '邮箱插件',
    value: 2,
  }, {
    label: '消息插件',
    value: 3,
  }, {
    label: '支付插件',
    value: 4,
  }, {
    label: 'Lemon管理平台',
    value: 5,
  }, {
    label: 'BladeX基础教学视频',
    value: 6,
  }, {
    label: 'Hr人事系统',
    value: 7,
  }, {
    label: '行政管理系统',
    value: 8,
  }, {
    label: 'Websocket插件',
    value: 9,
  }, {
    label: 'License授权管理',
    value: 10,
  }, {
    label: '企业内训系统',
    value: 11,
  }, {
    label: 'CICD平台搭建',
    value: 12,
  }, {
    label: '资产管理系统',
    value: 13,
  }, {
    label: '低代码平台',
    value: 14,
  }, {
    label: '可视化表单插件',
    value: 15,
  }, {
    label: '物联网组态系统',
    value: 16,
  }
]
/*export const config = [{
  label: '专业版',
  value: 0,
  money: 999
}, {
  label: 'BladeX企业版',
  value: 1,
  money: 3999
}, {
  label: '专业升企业',
  value: 2,
  money: 3000
}, {
  label: 'BladeX数据大屏版',
  value: 3,
  money: 5199
}]*/
export const list = [{
  title: '支持各种主流浏览器',
  first: true,
  second: true,
}, {
  title: '第三方登录（微信，QQ）',
  first: true,
  second: true,
}, {
  title: '炫彩主题（换色，换肤）',
  first: true,
  second: true,
}, {
  title: '短信登录',
  first: true,
  second: true,
}, {
  title: '菜单搜索',
  first: true,
  second: true,
}, {
  title: '标签导航',
  first: true,
  second: true,
}, {
  title: '错误日志监控',
  first: true,
  second: true,
}, {
  title: '动态加载图标',
  first: true,
  second: true,
}, {
  title: '锁屏功能',
  first: true,
  second: true,
}, {
  title: 'iframe支持',
  first: true,
  second: true,
}, {
  title: '路由权限',
  first: true,
  second: true,
}, {
  title: '菜单权限',
  first: true,
  second: true,
}, {
  title: '页面缓冲',
  first: false,
  second: true,
}, {
  title: '服务端动态路由',
  first: false,
  second: true,
}, {
  title: '高级嵌套路由',
  first: false,
  second: true,
}, {
  title: '无限级菜单',
  first: false,
  second: true,
}, {
  title: '多终端适配',
  first: false,
  second: true,
}, {
  title: 'IE9+支持',
  first: false,
  second: true,
}, {
  title: '源码讲解文档',
  first: false,
  second: true,
}, {
  title: 'Avue核心源码',
  first: false,
  second: true,
}, {
  title: '新功能优先体验',
  first: false,
  second: true,
}, {
  title: '技术支持',
  first: false,
  second: true,
}, {
  title: 'git私服',
  first: false,
  second: true,
}, {
  title: '加入内部吹B群',
  first: false,
  second: true,
}]
